import { minutesInHour } from './constants';

/**
 * Given a date, shows the UTC offset.
 * @param {Date} date a Date object for calculating offset.
 * @returns {string} - string representing the UTC offset
 */
export const dateUTCOffset = (date: Date): string => {
  const offsetInHours = (date.getTimezoneOffset() / minutesInHour) * -1;
  const hours = Math.round(offsetInHours);
  const minutes = (offsetInHours - hours) * minutesInHour;
  const prefix = hours >= 0 ? '+' : '';
  const hoursString = `${hours}`.padStart(2, '0');
  const minutesString = `${minutes}`.padStart(2, '0');

  return `${prefix}${hoursString}:${minutesString}`;
};
